/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createPagedResultOfInvoiceFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type PagedResultOfInvoice } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/invoices/by-customer/{customerNumber}
 */
export interface WithCustomerNumberItemRequestBuilder extends BaseRequestBuilder<WithCustomerNumberItemRequestBuilder> {
    /**
     * Returns one customer's invoices, newest invoice date first, up to 200 per page. Administrators can list any customer in the organization. A sales rep can list a customer they are allowed to see: every customer when their organization record has Can view all customers switched on, otherwise only customers whose RepNumber is one of theirs. A customer the caller may not see returns 404 rather than 403, so a customer number cannot be used to confirm that a customer exists.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PagedResultOfInvoice>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {ErrorResponse} error when the service returns a 404 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<WithCustomerNumberItemRequestBuilderGetQueryParameters> | undefined) : Promise<PagedResultOfInvoice | undefined>;
    /**
     * Returns one customer's invoices, newest invoice date first, up to 200 per page. Administrators can list any customer in the organization. A sales rep can list a customer they are allowed to see: every customer when their organization record has Can view all customers switched on, otherwise only customers whose RepNumber is one of theirs. A customer the caller may not see returns 404 rather than 403, so a customer number cannot be used to confirm that a customer exists.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<WithCustomerNumberItemRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Returns one customer's invoices, newest invoice date first, up to 200 per page. Administrators can list any customer in the organization. A sales rep can list a customer they are allowed to see: every customer when their organization record has Can view all customers switched on, otherwise only customers whose RepNumber is one of theirs. A customer the caller may not see returns 404 rather than 403, so a customer number cannot be used to confirm that a customer exists.
 */
export interface WithCustomerNumberItemRequestBuilderGetQueryParameters {
    /**
     * The page to return, starting at 1.
     */
    pageNumber?: number;
    /**
     * Invoices per page, 1 to 200.
     */
    pageSize?: number;
    /**
     * For a sales rep who belongs to several organizations: the organization to read from.It must be one of the organizations the caller's OrgCodes header grants.
     */
    useOrganizationId?: string;
}
/**
 * Uri template for the request builder.
 */
export const WithCustomerNumberItemRequestBuilderUriTemplate = "{+baseurl}/api/invoices/by-customer/{customerNumber}?pageNumber={pageNumber}&pageSize={pageSize}{&useOrganizationId*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const WithCustomerNumberItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: WithCustomerNumberItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPagedResultOfInvoiceFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
